import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { EvidenceDetail } from "./components/EvidenceDetail";
import { EvidencesContainer } from "./components/evidences.container";

function EvidenceDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.evidences.detail);
  const navigate = useNavigate();
  return <EvidenceDetail id={id} onBack={() => navigate("..")} />;
}

export function EvidencesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<EvidencesContainer />} />
        <Route path=":id" element={<EvidenceDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
